import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router';
import { atom, useAtomValue } from 'jotai';
import type { Atom } from 'jotai';

type FlowGuardConfig = {
  atoms: Atom<string>[];
  fallback: string;
};

export function useFlowGuard({ atoms, fallback }: FlowGuardConfig): boolean {
  const navigate = useNavigate();

  const readyAtom = useMemo(
    () => atom((get) => atoms.every((a) => get(a).length > 0)),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    atoms
  );

  const ready = useAtomValue(readyAtom);

  useEffect(() => {
    if (!ready) {
      navigate(fallback, { replace: true });
    }
  }, [ready, navigate, fallback]);

  return ready;
}
